"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScriptList = void 0;
const schemaComponents_1 = require("@/schemaComponents");
const hooks_1 = require("@mantine/hooks");
const react_split_1 = __importDefault(require("@uiw/react-split"));
require("@uiw/react-split/dist/dist.css");
const models_hook_1 = require("app/models.hook");
const color_1 = require("common/color");
const hooks_2 = require("common/hooks");
const react_1 = __importStar(require("react"));
const react_bootstrap_1 = require("react-bootstrap");
const Spinner_1 = __importDefault(require("react-bootstrap/Spinner"));
const react_router_dom_1 = require("react-router-dom");
const components_1 = require("utils/components");
const shortcutHandler_1 = require("utils/shortcutHandler");
const url_1 = require("utils/url");
const pages_1 = require("../../../../../../../pages");
const WordTableSidePanel_1 = __importDefault(require("../../WordTableSidePanel"));
const MultipleScriptsForm_1 = __importDefault(require("../MultipleScriptsForm"));
const ScriptItem_1 = require("../ScriptItem");
const FindReplace_1 = __importDefault(require("../ScriptItem/FindReplace"));
const ScriptTable_1 = require("../ScriptTable");
const TranslateAllButton_1 = __importDefault(require("../TranslateAllButton"));
const classes = __importStar(require("./ScriptList.module.scss"));
const conditionSchema_1 = require("./conditionSchema");
const schema_1 = require("./schema");
const CreateScriptModal_1 = require("./CreateScriptModal");
const updateScript_1 = require("@/utils/updateScript");
exports.ScriptList = react_1.default.memo(function ScriptList({ projectId, scriptId, segmentId, hasMore, fetching, scriptDoc, }) {
    var _a, _b;
    const searchParamAccessor = (0, url_1.useSearchParamAccessor)();
    const { value: langId, setValue: setLangId } = (0, hooks_2.useFieldAccessor)(searchParamAccessor, "langId");
    const [showCreateModal, setShowCreateModal] = (0, react_1.useState)(false);
    const [operationMode, setOperationMode] = (0, hooks_2.useSessionStorage)("operationMode", undefined);
    const [splitUI, setSplitUI] = (0, hooks_2.useSessionStorage)("spritUI", "vertical");
    const [highlightUnfinished, setHighlightUnfinished] = (0, hooks_2.useSessionStorage)("highlightUnfinished", false, false);
    const [highlightByStatus, setHighlightByStatus] = (0, hooks_2.useSessionStorage)("highlightByStatus", false, false);
    const [multipleSelection, setMultipleSelection] = (0, react_1.useState)(false);
    const [selectedScripts, setSelectedScripts] = (0, react_1.useState)([]);
    const { list: langList } = (0, models_hook_1.useLangList)({ projectId });
    const { list: systemLangList } = (0, models_hook_1.useSystemLangList)({});
    const systemLangMap = (0, react_1.useMemo)(() => Object.fromEntries((systemLangList === null || systemLangList === void 0 ? void 0 : systemLangList.map((item) => [item.langId, item.langName])) || []), [systemLangList]);
    const { conditionSelector, filterComponent, condition } = (0, schemaComponents_1.useConditionSelector)({
        schema: (0, conditionSchema_1.getConditionSchema)({ langId }),
        hideTimeCondition: true,
        unwrapped: true,
    });
    const langAppliedCondition = (0, react_1.useMemo)(() => {
        var _a;
        return Object.fromEntries(((_a = Object.entries(condition || {})) === null || _a === void 0 ? void 0 : _a.filter(([key]) => {
            const keyComponents = key.split(".");
            if (keyComponents.length !== 2)
                return true;
            const keyLangId = key.split(".")[1];
            return keyLangId === langId;
        })) || []);
    }, [condition, langId]);
    const { list, loading } = (0, models_hook_1.useReactiveScriptList)({
        projectId,
        segmentId,
        condition: langAppliedCondition,
    });
    const { list: comments } = (0, models_hook_1.useCommentList)({
        projectId,
        segmentId,
    });
    const navigate = (0, pages_1.useTypedNavigate)();
    const unsafeNavigate = (0, react_router_dom_1.useNavigate)();
    const commentsMap = (0, react_1.useMemo)(() => {
        // Sort all comments by createdAt once
        const sortedComments = [...(comments || [])].sort((a, b) => b.createdAt - a.createdAt);
        // Then group by scriptId
        return sortedComments.reduce((acc, comment) => {
            if (!comment.resolved) {
                if (!acc[comment.scriptId]) {
                    acc[comment.scriptId] = [];
                }
                acc[comment.scriptId].push(comment);
            }
            return acc;
        }, {});
    }, [comments]);
    const scriptListWithComments = (0, react_1.useMemo)(() => {
        var _a;
        return ((_a = list === null || list === void 0 ? void 0 : list.map((item) => {
            var _a;
            const commentsForScript = (_a = commentsMap === null || commentsMap === void 0 ? void 0 : commentsMap[item.scriptId]) !== null && _a !== void 0 ? _a : [];
            if (commentsForScript.length === 0) {
                return Object.assign(Object.assign({}, item), { unresolvedComment: "なし" });
            }
            else {
                return Object.assign(Object.assign({}, item), { unresolvedComment: (react_1.default.createElement(components_1.Button, { size: "sm", variant: "outline-secondary", onClick: (e) => {
                            var _a;
                            e.preventDefault();
                            e.stopPropagation();
                            const path = (_a = edit.path) === null || _a === void 0 ? void 0 : _a.call(edit, item);
                            const parsed = new URL("https://example.com" + path);
                            parsed.searchParams.set("sidePanelKind", "comments");
                            path && unsafeNavigate(parsed.pathname + parsed.search);
                        } },
                        commentsForScript.length,
                        "\u4EF6 /",
                        " ",
                        commentsForScript[0].comment
                            .map((c) => c.content)
                            .join("")
                            .slice(0, 20))) });
            }
        })) !== null && _a !== void 0 ? _a : []);
    }, [list, comments]);
    const totalOriginalChar = (0, react_1.useMemo)(() => list === null || list === void 0 ? void 0 : list.reduce((total, item) => {
        var _a, _b;
        return ((_b = (_a = item.text) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0) + total;
    }, 0), [list]);
    const totalTranslatedChar = (0, react_1.useMemo)(() => !langId
        ? 0
        : list === null || list === void 0 ? void 0 : list.reduce((total, item) => {
            var _a, _b;
            const text = ((_a = item.translations) === null || _a === void 0 ? void 0 : _a[langId]) || "";
            // Normalize all types of line breaks to LF before counting characters
            const normalizedText = text.replace(/\r\n|\r|\n/g, "\n");
            return ((_b = normalizedText.length) !== null && _b !== void 0 ? _b : 0) + total;
        }, 0), [list, langId]);
    const correctedPercent = (0, react_1.useMemo)(() => {
        if (!list || !langId)
            return null;
        const correctedCount = list.filter((item) => { var _a; return ((_a = item.translationStatus) === null || _a === void 0 ? void 0 : _a[langId]) === "corrected"; }).length;
        return Math.floor((correctedCount / list.length) * 100);
    }, [list, langId]);
    const translatedPercent = (0, react_1.useMemo)(() => {
        if (!list || !langId)
            return null;
        const translated = list.filter((item) => { var _a; return ((_a = item.translationStatus) === null || _a === void 0 ? void 0 : _a[langId]) === "translated"; }).length;
        return Math.floor((translated / list.length) * 100);
    }, [list, langId]);
    const unfinishedPercent = (0, react_1.useMemo)(() => {
        return 100 - (translatedPercent !== null && translatedPercent !== void 0 ? translatedPercent : 0) - (correctedPercent !== null && correctedPercent !== void 0 ? correctedPercent : 0);
    }, [translatedPercent, correctedPercent]);
    const onHoldPercent = (0, react_1.useMemo)(() => {
        var _a, _b;
        return Math.floor((((_a = list === null || list === void 0 ? void 0 : list.filter((item) => { var _a; return ((_a = item.tags) === null || _a === void 0 ? void 0 : _a[0]) === "skipped"; }).length) !== null && _a !== void 0 ? _a : 0) *
            100) /
            ((_b = list === null || list === void 0 ? void 0 : list.length) !== null && _b !== void 0 ? _b : 1));
    }, [list]);
    const { schema, title, edit, select, selectAll } = (0, react_1.useMemo)(() => ({
        title: "テキスト一覧",
        edit: {
            path: ({ scriptId }) => {
                const encodedScriptId = encodeURIComponent(scriptId);
                return (0, pages_1.resolveRoute)("UPDATE_SEGMENT_SCRIPT", { scriptId: encodedScriptId, projectId, segmentId }, { retainSearchParams: true });
            },
        },
        schema: (0, schema_1.getScliptListSchema)({ langId }),
        select: (script) => {
            var _a;
            if (!script) {
                setSelectedScripts([]);
                return;
            }
            // Check if the script is selectable based on operationMode
            if (operationMode) {
                const status = (_a = script.translationStatus) === null || _a === void 0 ? void 0 : _a[langId || ""];
                if ((operationMode === "corrector" && status !== "translated") ||
                    (operationMode === "translator" && status === "corrected")) {
                    return; // Do not select disabled scripts
                }
            }
            if (multipleSelection) {
                setSelectedScripts((prev) => {
                    if (prev.find((item) => item.scriptId === script.scriptId)) {
                        return prev.filter((item) => item.scriptId !== script.scriptId);
                    }
                    else {
                        return [...prev, script];
                    }
                });
            }
            else {
                setSelectedScripts([script]);
                const encodedScriptId = encodeURIComponent(script.scriptId);
                navigate("UPDATE_SEGMENT_SCRIPT", {
                    projectId,
                    scriptId: encodedScriptId,
                    segmentId,
                }, { retainSearchParams: true });
            }
        },
        selectAll: (checked) => {
            if (checked) {
                // If operationMode is active, only select eligible scripts
                if (operationMode && list) {
                    const eligibleScripts = list.filter((script) => {
                        var _a;
                        const status = (_a = script.translationStatus) === null || _a === void 0 ? void 0 : _a[langId || ""];
                        if (operationMode === "corrector") {
                            return status === "translated";
                        }
                        else if (operationMode === "translator") {
                            return status !== "corrected";
                        }
                        return true;
                    });
                    setSelectedScripts(eligibleScripts);
                }
                else {
                    setSelectedScripts(list !== null && list !== void 0 ? list : []);
                }
            }
            else {
                setSelectedScripts([]);
            }
        },
    }), [
        projectId,
        langId,
        multipleSelection,
        list,
        operationMode,
        navigate,
        segmentId,
    ]);
    const currentScriptIndex = (0, react_1.useMemo)(() => {
        if (!list)
            return -1;
        return list.findIndex((item) => {
            // eslint-disable-next-line eqeqeq
            return !!item.scriptId && item.scriptId == scriptId;
        });
    }, [list, scriptId]);
    const selectedIndexes = (0, react_1.useMemo)(() => {
        if (!list)
            return [];
        return selectedScripts.map((script) => {
            return list.findIndex((item) => item.scriptId === script.scriptId);
        });
    }, [selectedScripts, list]);
    const onAction = (0, react_1.useCallback)((action) => {
        var _a;
        if (action === "next") {
            if (!list)
                return;
            if (currentScriptIndex === -1)
                return;
            // Find the next eligible script based on operationMode
            let nextIndex = currentScriptIndex + 1;
            while (nextIndex < list.length) {
                const script = list[nextIndex];
                const status = (_a = script.translationStatus) === null || _a === void 0 ? void 0 : _a[langId || ""];
                // Skip scripts that should be disabled based on operationMode
                if (operationMode === "corrector" && status !== "translated") {
                    nextIndex++;
                    continue;
                }
                else if (operationMode === "translator" && status === "corrected") {
                    nextIndex++;
                    continue;
                }
                const nextScriptId = script.scriptId;
                if (!nextScriptId)
                    return;
                const encodedScriptId = encodeURIComponent(nextScriptId);
                navigate("UPDATE_SEGMENT_SCRIPT", {
                    projectId,
                    scriptId: encodedScriptId,
                    segmentId,
                }, { retainSearchParams: true });
                return;
            }
        }
    }, [
        list,
        scriptId,
        projectId,
        currentScriptIndex,
        navigate,
        segmentId,
        operationMode,
        langId,
    ]);
    const { data: segmentData, loading: segmentLoading } = (0, models_hook_1.useSegmentDoc)({
        projectId,
        segmentId,
    });
    const computedSplitMode = splitUI !== null && splitUI !== void 0 ? splitUI : "vertical";
    const nextScript = (0, react_1.useMemo)(() => {
        var _a;
        if (!scriptId)
            return null;
        if (!list)
            return null;
        const currentIndex = list.findIndex((item) => item.scriptId === scriptId);
        if (currentIndex === -1)
            return null;
        // Find the next eligible script based on operationMode
        let nextIndex = currentIndex + 1;
        while (nextIndex < list.length) {
            const script = list[nextIndex];
            const status = (_a = script.translationStatus) === null || _a === void 0 ? void 0 : _a[langId || ""];
            // Skip scripts that should be disabled based on operationMode
            if (operationMode === "corrector" && status !== "translated") {
                nextIndex++;
                continue;
            }
            else if (operationMode === "translator" && status === "corrected") {
                nextIndex++;
                continue;
            }
            return script;
        }
        return null;
    }, [list, scriptId, operationMode, langId]);
    const previousScript = (0, react_1.useMemo)(() => {
        var _a;
        if (!scriptId)
            return null;
        if (!list)
            return null;
        const currentIndex = list.findIndex((item) => item.scriptId === scriptId);
        if (currentIndex === -1)
            return null;
        // Find the previous eligible script based on operationMode
        let prevIndex = currentIndex - 1;
        while (prevIndex >= 0) {
            const script = list[prevIndex];
            const status = (_a = script.translationStatus) === null || _a === void 0 ? void 0 : _a[langId || ""];
            // Skip scripts that should be disabled based on operationMode
            if (operationMode === "corrector" && status !== "translated") {
                prevIndex--;
                continue;
            }
            else if (operationMode === "translator" && status === "corrected") {
                prevIndex--;
                continue;
            }
            return script;
        }
        return null;
    }, [list, scriptId, operationMode, langId]);
    (0, shortcutHandler_1.useShortcutRegister)("NextScript", (0, react_1.useCallback)(() => {
        if (!nextScript)
            return;
        unsafeNavigate(edit.path(nextScript));
    }, [nextScript, edit.path, unsafeNavigate]));
    (0, shortcutHandler_1.useShortcutRegister)("PreviousScript", (0, react_1.useCallback)(() => {
        if (!previousScript)
            return;
        unsafeNavigate(edit.path(previousScript));
    }, [previousScript, edit.path, unsafeNavigate]));
    const nextScriptHandler = (0, shortcutHandler_1.useShortcutHandler)("NextScript");
    (0, hooks_1.useHotkeys)([["mod + ArrowDown", nextScriptHandler, { preventDefault: true }]], [], true);
    const previousScriptHandler = (0, shortcutHandler_1.useShortcutHandler)("PreviousScript");
    (0, hooks_1.useHotkeys)([["mod + ArrowUp", previousScriptHandler, { preventDefault: true }]], [], true);
    // Update selected scripts data when scripts are updated
    (0, react_1.useEffect)(() => {
        setSelectedScripts((prev) => {
            return prev.map((item) => {
                const updated = list === null || list === void 0 ? void 0 : list.find((script) => script.scriptId === item.scriptId);
                if (!updated)
                    return item;
                return updated;
            });
        });
    }, [list]);
    const [isBackendReady, setBackendReady] = (0, react_1.useState)(true);
    // Check backend is ready only on mount
    (0, react_1.useEffect)(() => {
        const pingBackend = () => __awaiter(this, void 0, void 0, function* () {
            if (!list || list.length === 0) {
                return;
            }
            if (!multipleSelection) {
                return;
            }
            try {
                // Try to update the first script as a warmup check
                yield (0, updateScript_1.updateScript)({
                    projectId,
                    segmentId,
                    scriptId: list[0].scriptId,
                    data: list[0],
                });
                console.log("Backend is ready");
                setBackendReady(true);
            }
            catch (error) {
                console.error("Backend cold start detected:", error);
                setBackendReady(false);
            }
        });
        pingBackend();
    }, [multipleSelection]); // Only run on mount
    // Handle operationMode changes when current script becomes ineligible
    (0, react_1.useEffect)(() => {
        var _a, _b, _c;
        // Skip if no scriptId is selected or no list is available or in multipleSelection mode
        if (!scriptId || !list || multipleSelection)
            return;
        // Find the currently selected script in the list
        const currentIndex = list.findIndex((item) => item.scriptId === scriptId);
        if (currentIndex === -1)
            return;
        const currentScript = list[currentIndex];
        const status = (_a = currentScript.translationStatus) === null || _a === void 0 ? void 0 : _a[langId || ""];
        // Check if the current script is ineligible based on operationMode
        const isIneligible = (operationMode === "corrector" && status !== "translated") ||
            (operationMode === "translator" && status === "corrected");
        if (isIneligible) {
            // Find the next eligible script
            let foundEligibleScript = false;
            // First try to find the next eligible script
            for (let i = currentIndex + 1; i < list.length; i++) {
                const script = list[i];
                const scriptStatus = (_b = script.translationStatus) === null || _b === void 0 ? void 0 : _b[langId || ""];
                if (!(operationMode === "corrector" && scriptStatus !== "translated") &&
                    !(operationMode === "translator" && scriptStatus === "corrected")) {
                    // Found an eligible script, navigate to it
                    const encodedScriptId = encodeURIComponent(script.scriptId);
                    navigate("UPDATE_SEGMENT_SCRIPT", {
                        projectId,
                        scriptId: encodedScriptId,
                        segmentId,
                    }, { retainSearchParams: true });
                    foundEligibleScript = true;
                    break;
                }
            }
            // If no script found going forward, try to find one going backward
            if (!foundEligibleScript) {
                for (let i = currentIndex - 1; i >= 0; i--) {
                    const script = list[i];
                    const scriptStatus = (_c = script.translationStatus) === null || _c === void 0 ? void 0 : _c[langId || ""];
                    if (!(operationMode === "corrector" && scriptStatus !== "translated") &&
                        !(operationMode === "translator" && scriptStatus === "corrected")) {
                        // Found an eligible script, navigate to it
                        const encodedScriptId = encodeURIComponent(script.scriptId);
                        navigate("UPDATE_SEGMENT_SCRIPT", {
                            projectId,
                            scriptId: encodedScriptId,
                            segmentId,
                        }, { retainSearchParams: true });
                        foundEligibleScript = true;
                        break;
                    }
                }
            }
            // If no eligible script found at all, just unselect
            if (!foundEligibleScript) {
                // Unselect the current script by navigating to a script-less URL
                navigate("LIST_SEGMENT_SCRIPTS", {
                    projectId,
                    segmentId,
                }, { retainSearchParams: true });
                setSelectedScripts([]);
            }
        }
    }, [
        operationMode,
        list,
        scriptId,
        langId,
        navigate,
        projectId,
        segmentId,
        multipleSelection,
    ]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(components_1.PageHeader, { title: title, breadCrumbConfigs: [
                {
                    name: "プロジェクト一覧",
                    path: (0, pages_1.resolveRoute)("LIST_PROJECTS"),
                },
                {
                    name: "翻訳ファイル一覧",
                    path: (0, pages_1.resolveRoute)("LIST_SEGMENTS", { projectId }),
                },
                {
                    name: "テキスト一覧",
                },
            ] },
            react_1.default.createElement("span", { className: "ms-auto text-truncate", title: segmentData.segmentName }, segmentLoading ? (react_1.default.createElement(Spinner_1.default, { animation: "border", role: "status" })) : ((_a = segmentData.segmentName) !== null && _a !== void 0 ? _a : undefined)),
            react_1.default.createElement(react_router_dom_1.Link, { to: (0, pages_1.resolveRoute)("UPDATE_SEGMENT", {
                    segmentId,
                    projectId,
                }) },
                react_1.default.createElement(components_1.Button, { variant: "primary" },
                    react_1.default.createElement("i", { className: "mdi mdi-cog" })))),
        react_1.default.createElement("section", { style: { padding: "12px 8px 8px 8px" } },
            list && (react_1.default.createElement("div", { className: classes.header, style: {
                    zIndex: 20 /** テーブルのヘッダでセレクトボックスが隠れる問題を回避 */,
                } },
                react_1.default.createElement(schemaComponents_1.SchemaInput, { data: langId, schema: {
                        schemaType: "selector",
                        uiType: "normal",
                        options: [
                            {
                                value: null,
                                title: "言語を選択",
                            },
                            ...(langList || [])
                                .map((item) => ({
                                value: item.langId,
                                title: systemLangMap[item.langId],
                            }))
                                .filter((item) => item.title),
                        ],
                    }, onValueChange: setLangId }),
                react_1.default.createElement("span", { style: { padding: "5px 8px" } }, conditionSelector),
                react_1.default.createElement("div", { style: {
                        flex: 1,
                    } },
                    react_1.default.createElement("div", { style: {
                            display: "flex",
                            alignItems: "center",
                            gap: 10,
                        } },
                        !multipleSelection && (react_1.default.createElement("div", { style: {
                                minWidth: "300px",
                            } }, filterComponent)),
                        react_1.default.createElement(react_1.default.Fragment, null,
                            react_1.default.createElement("span", { style: {
                                    color: "#000",
                                    fontSize: "14px",
                                    fontWeight: 700,
                                    whiteSpace: "nowrap",
                                } },
                                currentScriptIndex !== -1
                                    ? currentScriptIndex + 1
                                    : "未選択",
                                "/",
                                list.length),
                            react_1.default.createElement("div", { style: {
                                    width: "80px",
                                    margin: "0 8px",
                                } },
                                react_1.default.createElement(ProgressBarWithTooltip, { unfinishedPercent: unfinishedPercent, translatedPercent: translatedPercent || 0, correctedPercent: correctedPercent || 0, onHoldPercent: onHoldPercent, totalOriginalChar: totalOriginalChar || 0, totalTranslatedChar: totalTranslatedChar || 0 }))),
                        react_1.default.createElement("div", { className: "d-flex align-items-center" },
                            react_1.default.createElement("div", { className: "flex-grow-1" },
                                react_1.default.createElement("div", { className: "field-body" },
                                    react_1.default.createElement("div", { className: "field" },
                                        react_1.default.createElement(TranslateAllButton_1.default, { confirmTitle: "\u3059\u3079\u3066\u306E\u30C6\u30AD\u30B9\u30C8\u3092\u7FFB\u8A33\u3057\u307E\u3059\u304B?", confirmContent: "\u7FFB\u8A33\u6587\u304C\u672A\u8A2D\u5B9A\u306E\u5168\u3066\u306E\u30C6\u30AD\u30B9\u30C8\u3092\u3001\u9806\u756A\u306B\u7FFB\u8A33\u3059\u308B\u6A5F\u80FD\u3067\u3059\u3002\u7FFB\u8A33\u5F8C\u3001\u30B9\u30C6\u30FC\u30BF\u30B9\u304C\u300C\u7FFB\u8A33\u6E08\u307F\u300D\u3068\u306A\u308A\u307E\u3059\u3002\u306A\u304A\u3001\u7FFB\u8A33\u6587\u304C\u3059\u3067\u306B\u8A2D\u5B9A\u3055\u308C\u3066\u3044\u308B\u30C6\u30AD\u30B9\u30C8\u306B\u3064\u3044\u3066\u306F\u3001\u30B9\u30C6\u30FC\u30BF\u30B9\u306F\u5909\u66F4\u3055\u308C\u307E\u305B\u3093\u3002", langId: langId !== null && langId !== void 0 ? langId : "", projectId: projectId, segmentId: segmentId, scripts: list }, "\u4E00\u62EC\u7FFB\u8A33"))))),
                        react_1.default.createElement(components_1.Button, { variant: "outline-primary", size: "base", onClick: () => setShowCreateModal(true), style: { minWidth: "40px" }, title: "\u65B0\u3057\u3044\u30C6\u30AD\u30B9\u30C8\u3092\u8FFD\u52A0" },
                            react_1.default.createElement("i", { className: "mdi mdi-plus" })),
                        react_1.default.createElement("div", { style: {
                                display: "flex",
                                alignItems: "center",
                                gap: 10,
                            } },
                            react_1.default.createElement(schemaComponents_1.SchemaInput, { data: multipleSelection, schema: {
                                    schemaType: "selector",
                                    options: [
                                        {
                                            icon: multipleSelection ? "check" : undefined,
                                            value: "multipleSelection",
                                            title: "複数選択",
                                            tooltip: "複数選択",
                                        },
                                    ],
                                    checkStyle: multipleSelection,
                                    noWrapText: true,
                                }, onValueChange: setMultipleSelection }),
                            multipleSelection && selectedIndexes.length > 0 && (react_1.default.createElement("p", { style: {
                                    whiteSpace: "nowrap",
                                    marginRight: "5px",
                                    color: "#3f3f46",
                                } },
                                "\u9078\u629E\u4E2D\u306E\u30C6\u30AD\u30B9\u30C8: ",
                                selectedIndexes.length,
                                "\u4EF6")),
                            !multipleSelection && (react_1.default.createElement(schemaComponents_1.SchemaInput, { data: operationMode, schema: {
                                    schemaType: "selector",
                                    options: [
                                        {
                                            value: "translator",
                                            title: "翻訳者",
                                            tooltip: "編集操作を翻訳者として行う操作に制限します",
                                        },
                                        {
                                            value: "corrector",
                                            title: "校閲者",
                                            tooltip: "編集操作を校閲者として行う操作に制限します",
                                        },
                                    ],
                                    noWrapList: true,
                                    noWrapText: true,
                                }, onValueChange: setOperationMode })),
                            react_1.default.createElement(schemaComponents_1.SchemaInput, { data: splitUI, schema: {
                                    schemaType: "selector",
                                    options: [
                                        splitUI === "vertical"
                                            ? {
                                                value: "horizontal",
                                                title: "画面",
                                                icon: "mdi-arrow-split-horizontal",
                                                tooltip: "画面を左右分割で表示します",
                                            }
                                            : {
                                                value: "vertical",
                                                title: "画面",
                                                icon: "mdi-arrow-split-vertical",
                                                tooltip: "画面を上下分割で表示します",
                                            },
                                    ],
                                    noWrapList: true,
                                    noWrapText: true,
                                    showIconWithTitle: true,
                                }, onValueChange: setSplitUI }),
                            react_1.default.createElement(schemaComponents_1.SchemaInput, { data: highlightUnfinished, schema: {
                                    schemaType: "selector",
                                    options: [
                                        {
                                            value: "highlight-unfinished",
                                            title: "未完了の翻訳をハイライト",
                                            icon: "mdi-file-alert",
                                            tooltip: "未完了の翻訳をハイライト",
                                        },
                                    ],
                                }, onValueChange: setHighlightUnfinished }),
                            react_1.default.createElement(schemaComponents_1.SchemaInput, { data: highlightByStatus, schema: {
                                    schemaType: "selector",
                                    options: [
                                        {
                                            value: "highlight-by-status",
                                            title: "ステータスによって色分けする",
                                            icon: "mdi-list-status",
                                            tooltip: "ステータスによって色分けする",
                                        },
                                    ],
                                }, onValueChange: setHighlightByStatus }),
                            multipleSelection && (react_1.default.createElement("div", { style: {
                                    width: "300px",
                                    display: "flex",
                                    alignItems: "center",
                                    marginRight: "8px",
                                    marginLeft: "4px",
                                    marginBottom: "5px",
                                } }, filterComponent))))))),
            react_1.default.createElement(CreateScriptModal_1.CreateScriptModal, { show: showCreateModal, onHide: () => setShowCreateModal(false), projectId: projectId, segmentId: segmentId }),
            react_1.default.createElement(components_1.SidePanelProvider, null, loading || !list ? (react_1.default.createElement("div", { className: "card" },
                react_1.default.createElement("div", { style: { padding: "20px" } },
                    react_1.default.createElement(Spinner_1.default, { animation: "border", role: "status" },
                        react_1.default.createElement("span", { className: "visually-hidden" }, "Loading..."))))) : (react_1.default.createElement("div", { className: "card", style: {
                    overflow: "auto",
                    boxShadow: "0px 0px 8px 0px #00000026",
                    borderRadius: "12px",
                    border: "solid 0.2px #D9D9D9",
                } },
                react_1.default.createElement(react_split_1.default, { style: {
                        display: "flex",
                        width: "100%",
                        height: "calc(100vh - 250px)",
                        overflow: "hidden",
                    }, mode: computedSplitMode, lineBar: true, renderBar: (_a) => {
                        var { onMouseDown } = _a, props = __rest(_a, ["onMouseDown"]);
                        return (react_1.default.createElement("div", Object.assign({}, props, { style: { boxShadow: "none", background: "transparent" } }),
                            react_1.default.createElement("div", { onMouseDown: onMouseDown, style: {
                                    backgroundColor: "#D9D9D9",
                                    boxShadow: "none",
                                } })));
                    } },
                    react_1.default.createElement("div", { style: Object.assign(Object.assign({}, (computedSplitMode === "horizontal"
                            ? {
                                width: "50%",
                                height: "calc(100vh - 250px)",
                            }
                            : { height: "50%" })), { position: "relative", paddingBottom: 37 }) },
                        react_1.default.createElement("div", { style: {
                                position: "absolute",
                                bottom: 0,
                                zIndex: 10,
                                padding: "8px",
                                width: "100%",
                                textAlign: "right",
                                fontWeight: "bold",
                                fontSize: 14,
                            } },
                            currentScriptIndex + 1,
                            " / ", scriptListWithComments === null || scriptListWithComments === void 0 ? void 0 :
                            scriptListWithComments.length),
                        react_1.default.createElement(ScriptTable_1.ScriptTable, { data: scriptListWithComments, schema: schema, hasMore: hasMore, fetching: fetching, editPath: edit.path, selectedIndex: currentScriptIndex, splitMode: computedSplitMode, langId: langId, highlightUnfinished: highlightUnfinished, highlightByStatus: highlightByStatus, multipleSelection: !!multipleSelection, selectedIndexes: selectedIndexes, select: select, selectAll: selectAll, operationMode: operationMode })),
                    react_1.default.createElement("div", { className: `${classes["script-list-form"]}`, key: langId || "", style: computedSplitMode === "horizontal"
                            ? { width: "50%", height: "calc(100vh - 250px)" }
                            : { height: "50%" } },
                        scriptId && !multipleSelection && (react_1.default.createElement(ScriptItem_1.ScriptItem, { key: (_b = scriptDoc.ref) === null || _b === void 0 ? void 0 : _b.path, langId: langId || "", projectId: projectId, onAction: onAction, scriptDoc: scriptDoc, segmentId: segmentId, splitMode: computedSplitMode, isLastElement: currentScriptIndex === list.length - 1 })),
                        !isBackendReady && (react_1.default.createElement("p", { className: "text-info" }, "\u30D0\u30C3\u30AF\u30A8\u30F3\u30C9\u306E\u6E96\u5099\u4E2D\u3067\u3059\u3002\u3057\u3070\u3089\u304F\u304A\u5F85\u3061\u304F\u3060\u3055\u3044...")),
                        selectedIndexes.length > 0 &&
                            multipleSelection &&
                            isBackendReady && (react_1.default.createElement(MultipleScriptsForm_1.default, { langId: langId || "", projectId: projectId, segmentId: segmentId, selectedScripts: selectedScripts.map((script) => {
                                const scriptCopy = Object.assign({}, script);
                                if ("unresolvedComment" in scriptCopy) {
                                    delete scriptCopy.unresolvedComment;
                                }
                                return scriptCopy;
                            }) })),
                        !scriptId && (react_1.default.createElement("div", { style: {
                                padding: "30px",
                                fontWeight: "bold",
                                textAlign: "center",
                            } }, "\u30EA\u30B9\u30C8\u304B\u3089\u30C6\u30AD\u30B9\u30C8\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044")),
                        react_1.default.createElement(FindReplace_1.default, { projectId: projectId, segmentId: segmentId, langId: langId || "", scriptList: list }),
                        react_1.default.createElement(WordTableSidePanel_1.default, { projectId: projectId, langId: langId, condition: condition })))))))));
});
const ProgressBarWithTooltip = ({ unfinishedPercent, translatedPercent, correctedPercent, onHoldPercent, totalOriginalChar, totalTranslatedChar, }) => {
    const segments = [
        {
            label: "未着手",
            percent: unfinishedPercent,
            color: color_1.statusColor.null,
        },
        {
            label: "翻訳済",
            percent: translatedPercent,
            color: color_1.statusColor.translated,
        },
        {
            label: "校閲済",
            percent: correctedPercent,
            color: color_1.statusColor.corrected,
        },
        {
            label: "保留",
            percent: onHoldPercent,
            color: color_1.statusColor.skipped,
        },
    ].filter((segment) => segment.percent > 0);
    return (react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { placement: "bottom", offset: [0, 10], overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, { style: {
                zIndex: 11,
                width: "150px",
                backgroundColor: "white",
                border: "1px solid #ccc",
                borderRadius: "6px",
                whiteSpace: "nowrap",
                boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
            }, bsPrefix: "ctooltip" },
            react_1.default.createElement("div", { style: { backgroundColor: "white" } },
                react_1.default.createElement("div", null,
                    "\u672A\u7740\u624B\uFF1A ",
                    unfinishedPercent.toFixed(0),
                    "%"),
                react_1.default.createElement("div", null,
                    "\u7FFB\u8A33\u6E08\uFF1A ",
                    translatedPercent.toFixed(0),
                    "%"),
                react_1.default.createElement("div", null,
                    "\u6821\u95B2\u6E08\uFF1A ",
                    correctedPercent.toFixed(0),
                    "%"),
                react_1.default.createElement("div", null,
                    "\u4FDD\u7559\uFF1A ",
                    onHoldPercent.toFixed(0),
                    "%"),
                react_1.default.createElement("hr", { style: {
                        border: "none",
                        borderTop: "1px dashed grey",
                        margin: "8px -8px",
                    } }),
                react_1.default.createElement("div", null,
                    "\u7FFB\u8A33\u524D\uFF1A ",
                    totalOriginalChar.toLocaleString(),
                    "\u5B57"),
                react_1.default.createElement("div", null,
                    "\u7FFB\u8A33\u5F8C\uFF1A ",
                    totalTranslatedChar.toLocaleString(),
                    "\u5B57"))) },
        react_1.default.createElement(react_bootstrap_1.ProgressBar, { style: {
                width: "80px",
                height: "15px",
                cursor: "pointer",
                borderRadius: "4px",
                overflow: "hidden",
                border: "solid 1px #D9D9D9",
            } }, segments.map((segment, index) => (react_1.default.createElement(react_bootstrap_1.ProgressBar, { key: index, now: segment.percent, style: { backgroundColor: segment.color }, isChild: true }))))));
};
